export default "__VITE_ASSET__d097fb68__"